import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { subscribeToWallet, subscribeToTransactions } from '../../services/walletService';

interface WalletState {
  wallet: any | null;
  transactions: any[];
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
}

const initialState: WalletState = {
  wallet: null,
  transactions: [],
  status: 'idle',
  error: null,
};

const walletSlice = createSlice({
  name: 'wallet',
  initialState,
  reducers: {
    setWallet(state, action: PayloadAction<any | null>) {
      state.wallet = action.payload;
    },
    setTransactions(state, action: PayloadAction<any[]>) {
      state.transactions = action.payload;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
  },
});

export const { setWallet, setTransactions, setError } = walletSlice.actions;
export default walletSlice.reducer;

// Thunks to manage subscriptions
export const subscribeToWalletAndTransactions = (walletId: string) => (dispatch: any) => {
  // Subscribe to wallet updates
  const unsubscribeWallet = subscribeToWallet(walletId, (wallet) => {
    if (wallet) {
      dispatch(setWallet(wallet));
    } else {
      dispatch(setError('Wallet not found slice'));
    }
  });

  // Subscribe to transactions updates
  const unsubscribeTransactions = subscribeToTransactions(walletId, (transactions) => {
    dispatch(setTransactions(transactions));
  });

  // Return unsubscribe functions to stop listening when needed
  return () => {
    unsubscribeWallet();
    unsubscribeTransactions();
  };
};